import React from 'react';
import PropTypes from 'prop-types';
// Components
import LinkHandler from '../../link-handler';

const MenuItem = ({ item, active }) => {
  if (!item) return null;
  const { label, path } = item;

  return (
    <li>
      {active ? label : <LinkHandler link={{ path }}>{label}</LinkHandler>}
    </li>
  );
};

MenuItem.propTypes = {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    path: PropTypes.string.isRequired,
  }),
  active: PropTypes.bool,
};

export default MenuItem;
